<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div :class="['content', config.navbarPosition === 'left' ? 'content-left' : '', config.navbarPosition === 'left' && config.navbarStyle !== 'one' ? 'content-left-two' : '']"
       @drop.stop="drop($event)" @dragover.stop="allowDrop($event)">
    <template v-for="(item, itemIndex) in config.children" :key="itemIndex">
      <template v-if="item.children && item.children.length > 0">
        <template v-for="(list, index) in getList(item.children)">
          <div v-if="itemIndex === config.selected && !layout[list].viewShow"
               :key="index"
               :style="config.navbarPosition === 'left' && layout[list].type === 'summary' ? 'width:calc(100% - 16px);' : ''"
               :class="['content-list', config.navbarStyle === 'one' ? '' : 'header-style-two']">
               <!-- (!layout[list].nameShow || isFrontEnd) && layout[list].type !== 'text'  -->
               <select-box
                  v-if="(!layout[list].nameShow || layout[list].toolbar || isFrontEnd) && layout[list].type !== 'text'"
                  :style="!layout[list].nameShow ? 'min-height: 40px;' : ''"
                  :copy="false"
                  :data="layout[list]"
                  :index="index"
                  :layoutIndex="layout.findIndex(its => its.i === layout[list].i)"
                  :theme="theme"
                  :draggable="draggable"
                  :resizable="false"
                  :isFrontEnd="isFrontEnd"
                  :width="styleSync.width"
                  :height="styleSync.height"
                  @handle="(e) => handle(e, layout[list].i)"
                  @upchart="(val) => upchart(val, layout[list], layout.findIndex(its => its.i === layout[list].i))"
                >
                  <toolbar v-if="layout[list].toolbar"
                     v-model:config="layout[list]"
                     :isFrontEnd="isFrontEnd"
                     :configComponent="layout[list]"
                     :summary="layout[list].summary"
                     @closeButton="closeButton"
                     @upSummary="upSummary"
                     @change-filed="changeFiled(layout[list], $event)"
                     @usual="(val) => usual(val, layout[list].i)"
                     @searchRelevanceConfig="searchRelevanceConfig"
                     @singleRelevanceConfig="(val) => singleRelevanceConfig(val, layout[list])" />
                </select-box>
            <template v-if="layout[list].type === 'detailed'">
              <div
                class="grid-table"
                :style="[getHeight(layout[list]),bgfillSet(layout[list].bgfllStyle,layout[list].transparentBackground)]"
                v-if="(layout[list].loadSetting && layout[list].loadSetting === 'scroll') ||
              (!layout[list].skeletonLoading ||
              layout[list].skeletonLoading === false ||
              layout[list].appId == '')">
                <!-- 表格内容 -->
                <table-detail :tableDetailData="layout[list]"
                              @loadPage="loadPage"
                              @goSearch="$emit('goSearchList', $event)"
                              @selectedTable="selectedTable"
                              @relevanceFun="changeRelevanceFun"
                              @singleRelevance="singleRelevance" />
              </div>

              <!-- 骨架屏 -->
              <skeleton-view
                style="height: 77%"
                v-if="(!layout[list].loadSetting || layout[list].loadSetting !== 'scroll') && (layout[list].skeletonLoading === true && layout[list].appId && layout[list].appId != '')"
                :h="config.h - 5"/>

              <!-- 分页 -->
              <drageGridNav v-if="(!layout[list].loadSetting || layout[list].loadSetting === 'pages') &&
              (!layout[list].skeletonLoading ||
              layout[list].skeletonLoading === false ||
              layout[list].appId == '')"
                            :subScript="itemIndex"
                            :pageTotal="layout[list].pageTotal"
                            :article="layout[list].article"
                            :curpage="layout[list].curpage"
                            :disabled="disabled"
                            @pageChange="pageChange"
              />

            </template>
            <template v-else-if="layout[list].type === 'summary'">
              <div class="img-list">
                <template v-for="(tt, tti) in getLegend(layout[list])" :key="tti">
                  <div class="img-tt">
                    <div class="img-tt-i"><icon-module :config="tt.img"></icon-module></div>
                    <div class="img-tt-v">{{ tt.value }}</div>
                  </div>
                </template>
              </div>
              <!-- 表格内容 -->
              <div
                class="grid-table"
                :style="[getHeight(layout[list]),bgfillSet(layout[list].bgfllStyle,layout[list].transparentBackground)]"
                v-if="!layout[list].skeletonLoading ||
              layout[list].skeletonLoading === false ||
              layout[list].appId == ''">
                <template v-if="layout[list].row && layout[list].row[0] && layout[list].row[0].partition">
                  <template v-for="(itt, index) in layout[list].partitionList" :key="itt + index">
                    <partition :row="layout[list].row"
                      :partitionKey="itt"
                      :column="layout[list].column"
                      :summary="layout[list].summary"
                      :topCount="layout[list].topCount"
                      :id="layout[list].i"
                      :isSummary="layout[list].isSummary"
                      :lineClamp="Number(layout[list].lineClamp)"
                      :titleConfig="layout[list].titleConfig"
                      :valueConfig="layout[list].valueConfig"
                      :rowWidth="layout[list].rowWidth"
                      :tableData="layout[list].tableData"
                      :mergeTable="layout[list].tableMerge"
                      :merge="layout[list].merge"
                      :isFrontEnd="isFrontEnd"
                      :total="layout[list].pageTotal || 0"
                      :totalPage="layout[list].pages || 0"
                      :page="layout[list].devCurpage"
                      :overflowTable="layout[list].overflow"
                      :index="index + ''"
                      :user="layout[list].user"
                      :config="layout[list]"
                      :dashboardId="dashboardId"
                      @rSetReviseRow="rSetReviseRow"
                      :reviseObj="reviseObj[layout[list].i]"
                      :saveRevise="saveRevise[layout[list].i]"
                      @relevanceFun="changeRelevanceFun"
                      @goSearch="$emit('goSummarySearch', $event)"
                      :selectRow="layout[list].selectRow"
                      :selectCloum="layout[list].selectCloum"
                      :selectPage="layout[list].selectPage"
                      :summaryObj="getSummary(layout[list].summary)" />
                  </template>
                </template>
                <template v-else>
                  <template v-if="isFrontEnd">
                    <sumTable
                      v-if="layout[list].merge && layout[list].merge.length > 0"
                      :row="layout[list].row"
                      :column="layout[list].column"
                      :summary="layout[list].summary"
                      :topCount="layout[list].topCount"
                      :id="layout[list].i"
                      :ref="'sumTableRefs_' + layout[list].i"
                      :isSummary="layout[list].isSummary"
                      :lineClamp="Number(layout[list].lineClamp)"
                      :titleConfig="layout[list].titleConfig"
                      :valueConfig="layout[list].valueConfig"
                      :rowWidth="layout[list].rowWidth"
                      :tableData="tableFun(layout[list].tableData || [], layout[list].devCurpage, layout[list].devArticle)"
                      :mergeTable="tableMergeFun(tableFun(
                        layout[list].tableData || [],
                        layout[list].devCurpage,
                        layout[list].devArticle), layout[list])"
                      :merge="layout[list].merge"
                      :total="layout[list].pageTotal ? layout[list].pageTotal : layout[list].tableData.length"
                      :totalPage="layout[list].pages ? layout[list].pages : Math.ceil(layout[list].tableData.length / layout[list].devArticle)"
                      :page="layout[list].devCurpage"
                      :overflowTable="layout[list].overflow"
                      :index="index + ''"
                      :config="layout[list]"
                      :dashboardId="dashboardId"
                      @rSetReviseRow="rSetReviseRow"
                      :reviseObj="reviseObj[layout[list].i]"
                      :saveRevise="saveRevise[layout[list].i]"
                      @relevanceFun="changeRelevanceFun"
                      @goSearch="$emit('goSummarySearch', $event)"
                      :selectRow="layout[list].selectRow"
                      :selectCloum="layout[list].selectCloum"
                      :selectPage="layout[list].selectPage"
                      :summaryObj="getSummary(layout[list].summary)"
                    />
                  </template>
                  <template v-else>
                    <sumTable
                      v-if="layout[list].merge && layout[list].merge.length > 0"
                      :row="layout[list].row"
                      :column="layout[list].column"
                      :summary="layout[list].summary"
                      :topCount="layout[list].topCount"
                      :id="layout[list].i"
                      :ref="'sumTableRefs_' + layout[list].i"
                      :isSummary="layout[list].isSummary"
                      :lineClamp="Number(layout[list].lineClamp)"
                      :titleConfig="layout[list].titleConfig"
                      :valueConfig="layout[list].valueConfig"
                      :rowWidth="layout[list].rowWidth"
                      :tableData="layout[list].tableData"
                      :mergeTable="layout[list].tableMerge"
                      :merge="layout[list].merge"
                      :isFrontEnd="isFrontEnd"
                      :total="layout[list].pageTotal || 0"
                      :totalPage="layout[list].pages || 0"
                      :page="layout[list].devCurpage"
                      :overflowTable="layout[list].overflow"
                      :index="index + ''"
                      :user="layout[list].user"
                      :config="layout[list]"
                      :dashboardId="dashboardId"
                      @rSetReviseRow="rSetReviseRow"
                      :reviseObj="reviseObj[layout[list].i]"
                      :saveRevise="saveRevise[layout[list].i]"
                      @relevanceFun="changeRelevanceFun"
                      @goSearch="$emit('goSummarySearch', $event)"
                      :selectRow="layout[list].selectRow"
                      :selectCloum="layout[list].selectCloum"
                      :selectPage="layout[list].selectPage"
                      :summaryObj="getSummary(layout[list].summary)"
                    />
                    <div v-else class="no-data">
                      <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
                      <div>暂无数据</div>
                    </div>
                  </template>
                </template>
              </div>

              <!-- 骨架屏 -->
              <skeleton-view
                style="height: 77%"
                v-if="layout[list].skeletonLoading === true && layout[list].appId && layout[list].appId != ''"
                :h="config.h - 5"
              />

              <!-- 分页 -->
              <drageGridNav
                v-if="!layout[list].skeletonLoading ||
              layout[list].skeletonLoading === false ||
              layout[list].appId == ''"
                :subScript="itemIndex"
                :pageTotal="layout[list].pageTotal
                ? layout[list].pageTotal
                : layout[list].tableData
                ? layout[list].tableData.length
                : 0"
                :article="layout[list].devArticle"
                :curpage="layout[list].devCurpage"
                :disabled="disabled"
                @pageChange="sumPageChange"
              />
              <!-- <div v-if="layout[list].upRevise" class="revise">
                <el-button size="small" @click="closeButton(layout[list].i)">取消</el-button>
                <el-button size="small" type="primary" @click.stop="upSummary({ uId: layout[list].i, i: layout[list].upRevise.i, insideInfo: layout[list].upRevise.config })">保存</el-button>
              </div> -->
            </template>
            <template v-else-if="layout[list].type === 'indicatorsBread'">
              <!-- 表格内容 -->
              <div
                class="grid-table"
                :style="[{height:'calc(100% - ' + ((layout[list].type !== 'indicatorsBread' || layout[list].type === 'indicatorsBread' && layout[list].chartType !== 'indicators' || layout[list].type === 'indicatorsBread' && layout[list].chartType === 'indicators' && (layout[list].row && layout[list].row.length === 0 || !layout[list].row) ? 53 : 102) + (layout[list].toolbar ? 40 : 0)) + 'px)'},bgfillSet(layout[list].bgfllStyle,layout[list].transparentBackground)]"
                v-if="
              !layout[list].skeletonLoading ||
              layout[list].skeletonLoading === false ||
              layout[list].appId == ''
            "
              >
                <!-- 指标图表格内容 -->
                <indicators-details
                  v-if="layout[list].chartType === 'indicators'"
                  :tableData="layout[list].tableData"
                  :row="layout[list].row"
                  :summary="layout[list].summary"
                  :reName="layout[list].reName"
                  :total="layout[list].totalValue"
                  :fontSize="layout[list].h"
                  :defaultStyleConfig="layout[list].styleConfig"
                  :id="layout[list].i"
                  :isRowVirtual="layout[list].isRowVirtual"
                  :isFrontEnd="isFrontEnd"
                  :page="layout[list].devCurpage"
                  :ref="'indicatorsRefs_' + layout[list].i"
                  :selectPage="layout[list].selectPage"
                  :user="layout[list].user"
                  v-model:projectionTransparent="layout[list].projectionTransparent"
                  v-model:transparentBackground="layout[list].transparentBackground"
                  :nameShow="layout[list].nameShow"
                  @relevanceFun="changeRelevanceFun"
                />

                <!-- 饼图表格内容 -->
                <bread-details
                  v-if="layout[list].chartType === 'bread'"
                  :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  :tableData="layout[list].tableData"
                  :echartsTempId="layout[list].echartsTempId"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  :user="layout[list].user"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                />

                <!-- 面积图表格内容 -->
                <proportion-details
                  v-if="layout[list].chartType === 'proportion'"
                  :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="proportionRefs"
                  :tableData="layout[list].tableData"
                  :echartsTempId="layout[list].echartsTempId"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :column="layout[list].column"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />

                <!-- 柱状图表格内容 -->
                <columnar-details
                  v-if="layout[list].chartType === 'columnar'"
                  :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="columnarRefs"
                  :tableData="layout[list].tableData"
                  :echartsTempId="layout[list].echartsTempId"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :column="layout[list].column || []"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />
                <!-- 柱状堆积图表格内容 -->
                <columnar-stacking
                  v-if="layout[list].chartType === 'columnarStacking'"
                  :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="columnarRefs"
                  :tableData="layout[list].tableData"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :summary="layout[list].summary"
                  :column="layout[list].column"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />

                <!-- 环形图表格内容 -->
                <annular-details
                  v-if="layout[list].chartType === 'annular'"
                  :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="annularRefs"
                  :tableData="layout[list].tableData"
                  :echartsTempId="layout[list].echartsTempId"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />

                <!-- 折线图表格内容 -->
                <broken-line-details
                  v-if="layout[list].chartType === 'brokenLine'"
                  :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="brokenLineRefs"
                  :tableData="layout[list].tableData"
                  :echartsTempId="layout[list].echartsTempId"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :summary="layout[list].summary"
                  :column="layout[list].column"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />

                <!-- 条形图表格内容 -->
                <bar-type-details
                  v-if="layout[list].chartType === 'barType'"
                  :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="barTypeRefs"
                  :tableData="layout[list].tableData"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :column="layout[list].column"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />

                <!-- 散点图 -->
                <scatter
                  v-if="layout[list].chartType === 'scatter'"
                  :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="scatterRefs"
                  :tableData="layout[list].tableData"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :column="layout[list].column"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />
                <!-- 雷达图  -->
                <radar
                  v-if="layout[list].chartType === 'radar'"
                  :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="radarRefs"
                  :tableData="layout[list].tableData"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :column="layout[list].column"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />
                <!-- 时间轴表格内容 -->
                <timeline
                  v-if="layout[list].chartType === 'timeline'"
                   :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="timelineRefs"
                  :tableData="layout[list].tableData"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :column="layout[list].column || []"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />
                <!-- K线图 -->
                <candlestick
                  v-if="layout[list].chartType === 'candlestick'"
                   :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="candlestickRefs"
                  :tableData="layout[list].tableData"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :column="layout[list].column"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />
                <!-- 热力图 -->
                <heatmap
                  v-if="layout[list].chartType === 'heatmap'"
                   :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="heatmapRefs"
                  v-model:tableData="layout[list].tableData"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :column="layout[list].column"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                />
                <!-- 矩形树图 -->
                <treemap
                  v-else-if="layout[list].chartType === 'treemap'"
                    :theme="layout[list].themeConfig && JSON.stringify(layout[list].themeConfig) != '{}' ? layout[list].themeConfig : theme"
                  :width="styleSync.width"
                  :viewShow="layout[list].viewShow"
                  ref="treemapRefs"
                  :tableData="layout[list].tableData"
                  :id="layout[list].i"
                  :row="layout[list].row"
                  :column="layout[list].column"
                  :summary="layout[list].summary"
                  :isFrontEnd="isFrontEnd"
                  @relevanceFun="changeRelevanceFun"
                  :changeSize="layout[list].w + layout[list].h"
                  :user="layout[list].user"
                  :config="layout[list].treemapConfig"
                />

              </div>

              <!-- 骨架屏 -->
              <skeleton-view
                style="height: 77%"
                v-if="layout[list].skeletonLoading === true && layout[list].appId && layout[list].appId != ''"
                :h="config.h < 10 ? 15 : config.h - 5"
              />

              <!-- 分页 -->
              <drageGridNav
                v-if="
                  (!layout[list].skeletonLoading &&
                    layout[list].chartType === 'indicators' &&
                    layout[list].isRowVirtual === false) ||
                  (layout[list].appId == '' &&
                    layout[list].chartType === 'indicators' &&
                    layout[list].isRowVirtual === false)
                "
                :subScript="index"
                :pageTotal="
                  layout[list].pageTotal
                    ? layout[list].pageTotal
                    : layout[list].tableData
                    ? layout[list].tableData.length
                    : 0
                "
                :article="layout[list].devArticle"
                :curpage="layout[list].devCurpage"
                :disabled="disabled"
                @pageChange="indicatorsChange"
              />
            </template>
            <template v-else-if="layout[list].type === 'text'">
              <div
                class="grid-text"
                :style="[{height:'calc(100% - ' + (isFrontEnd ? 53 : 20) +'px)'},bgfillSet(layout[list].bgfllStyle,layout[list].transparentBackground)]"
              >
                <text-cpn 
                  :data="layout[list]"
                  :index="index"
                  @handle="(e) => handle(e, layout[list].i)"
                  :isFrontEnd="isFrontEnd"
                  @handleSet="(val) => { $emit('handleSet', {val, list}) }"
                 />
              </div>
            </template>
						<template v-else-if="layout[list].type === 'swiper'">
							<!-- 图片组件 -->
							<div :class="['grid-drage', layout[list].transparentBackground ? 'bTransparent' : '', layout[list].projectionTransparent ? 'pTransparent' : '']"
							style="box-shadow:none;border:none;"
							:style="{height:'calc(100% - ' + (isFrontEnd ? 53 : 20) +'px)'}">
								<!-- 滚动图 -->
                <roll
                  ref="gird-item"
                  :dataInfo="layout[list]"
                  :isPreview="false"
                  :themeColor="'#4e86ff'"
                  :compRadius="'n'"
                  @edit="editToolsFun"
                  :style="{
                    borderRadius: 0
                  }"
                />
							</div>
						</template>
          </div>
        </template>
      </template>
      <div v-if="(!item.children || item.children.length === 0) && itemIndex === config.selected" class="no-content">
        <template v-if="isFrontEnd">
          <el-icon class="no-content-icon"><Plus /></el-icon>
          <div class="no-content-text">请拖入所需要的组件</div>
        </template>
        <div v-else class="no-content-text">暂无组件</div>
      </div>
    </template>
    <div v-if="!config.children || config.children.length === 0" class="no-content">
      <template v-if="isFrontEnd">
        <el-icon class="no-content-icon"><Plus /></el-icon>
        <div class="no-content-text">您还未添加栏目，快去<span @click="addCount" class="add-count">添加栏目</span>吧~</div>
      </template>
      <div v-else class="no-content-text">暂无栏目</div>
    </div>
  </div>
</template>

<script>
import selectBox from '../selectBox.vue';//- 操作组件
import skeletonView from '@/components/common/skeletonDrawing.vue';//- 仪表盘内容骨架屏加载组件
import drageGridNav from "../drageGridNav.vue";//- 分页控件骨架
import tableDetail from '@/components/clientSide/instrument/common/detailed/tableDetail.vue';//- 仪表盘明细表格骨架
import sumTable from '@/components/clientSide/instrument/common/summaryModel/sumTable.vue'//- 汇总表显示组件骨架
import indicatorsDetails from '../indicatorsBread/indicatorsDetails.vue'//- 指标图图表骨架
import breadDetails from '../indicatorsBread/breadDetails.vue'//- 饼图图表骨架
import proportionDetails from '../indicatorsBread/proportionDetails.vue'//- 面积图图表骨架
import columnarDetails from '../indicatorsBread/columnarDetails.vue'//- 柱状图图表骨架
import columnarStacking from '../indicatorsBread/columnarStacking.vue'//- 柱状堆积图
import annularDetails from '../indicatorsBread/annularDetails.vue'//- 环形图图表骨架
import brokenLineDetails from '../indicatorsBread/brokenLineDetails.vue'//- 折线图图表骨架
import barTypeDetails from '../indicatorsBread/barTypeDetails.vue'//- 条形图图表骨架
import scatter from '../indicatorsBread/scatter.vue'// 散点图
import timeline from '../indicatorsBread/timeline.vue'// 时间轴
import radar from '../indicatorsBread/radar.vue'// 雷达图
import candlestick from '../indicatorsBread/candlestick.vue'// k线图
import heatmap from '../indicatorsBread/heatmap.vue'// k线图
import treemap from '../indicatorsBread/treemap.vue'// k线图
import toolbar from '../toolbar/index'
import textCpn from '../text/index' // 文本组件
import { filterStr, getHidenList } from '@/api/instrumentControl';//- 封装方法请求
import partition from '../summaryModel/partition.vue'

import { cloneDeep } from 'lodash'
import { defineAsyncComponent } from 'vue';

export default {
  name: "container-content",
  components: {
    selectBox,
    skeletonView,
    drageGridNav,
    tableDetail,
    sumTable,
    indicatorsDetails,
    breadDetails,
    proportionDetails,
    columnarDetails,
    columnarStacking,
    annularDetails,
    brokenLineDetails,
    barTypeDetails,
    scatter,
    timeline,
    radar,
    candlestick,
    heatmap,
    toolbar,
    treemap,
    textCpn,
    partition,
    roll: defineAsyncComponent(() => import('../roll/index.vue')), // 滚动图
    IconModule: defineAsyncComponent(() => import('@/components/common/icon/iconModule.vue'))
  },
  props: {
    layout: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object
    },
    index: {
      type: Number
    },
    isFrontEnd: Boolean,
    draggable: Boolean,
    disabled: Boolean,
    theme: Object,
    styleSync: {
      type: Object,
      default: () => {
        return {
          width: 0,
          height: 0
        }
      }
    },
    reviseObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    dashboardId: String,
    saveRevise: Object
  },
  data () {
    return {
      tableSelectValue: {},

			// 去编辑暂存
      goEdit: {},
      isEdit: false,
    }
  },
  methods: {
    getLegend (item) {
      if (item.legend && item.legendKey) {
        const ind = item.summary.findIndex(it => it.title === item.legendKey)
        if (ind !== -1 && item.summary[ind].colorConfig && item.summary[ind].colorConfig.colorType == 3) {
          return item.summary[ind].colorConfig.options || []
        }
      }
      return []
    },
    closeButton (i) {
      this.$emit('closeButton', i)
    },
    rSetReviseRow (config) {
      console.log('rSetReviseRow', config)
      this.$emit('rSetReviseRow', config)
    },
    upSummary (config) {
      this.$emit('upSummary', config)
    },
    changeFiled(item, list) {
      item.skeletonLoading = true;
      const defaultMerge = item.defaultMerge
      const column = item.column
      let row = 1
      if (column.length === 0) {
        row = item.row.length
      }
      const first = defaultMerge.slice(0, row)
      const top = getHidenList(defaultMerge.slice(row, defaultMerge.length), list)
      top.unshift(...first)
      // item.merge = top
      this.$set(item, 'merge', top)
      setTimeout(() => {
        item.skeletonLoading = false; 
      }, 300);
    },
    getSummary (summary) {
      const ob = {
        configNumber: {},
        colorConfig: {},
        headerView: {}
      }
      for (const i of summary) {
        if (i && i.isFormatNum) {
          ob.configNumber[i.name] = i.configNumber
        }
        if (i && i.isColor) {
          ob.colorConfig[i.name] = i.colorConfig
        }
        if (i.isShow) ob.headerView[i.name] = i.isShow
      }
      return ob
    },
    upchart (val, item, index) {
      if (!this.isFrontEnd) {
        this.$set(this.layout[index], 'echartsTempId', (val.echartsTempId || val.echartsTempId === 0 ? val.echartsTempId : -1))
        this.$set(this.layout[index], 'chartType', (val.chartType || val))
        this.$set(this.layout[index], 'themeConfig', (val.themeConfig || {}))
        this.handle({index: index, item: this.layout[index], status: 'update'})
      }
    },
    usual (config, i) {
      console.log('从其里面点击', config, i)
      this.$emit('contentUsual', {config: config, i: i})
    },
    retRefresh (val) {
      const ind = this.layout.findIndex(its => its.i === val.i)
      if (ind !== -1) this.$emit('contentRetRefresh', ind)
    },
    selectedTable (val) {
      if (!this.isFrontEnd) this.tableSelectValue = val
    },
    singleRelevanceConfig (val, item) {
      if (this.isFrontEnd) return
      console.log('单个点击的val', val)
      console.log('单个点击查询出来', val, item)
      if (item.type === 'detailed' && JSON.stringify(this.tableSelectValue) === '{}' && ((val.item.linked && val.item.linked.length > 0) || (val.item.customize && val.item.customize.length > 0))) {
        let isCustom = false
        if (Array.isArray(val.item.linked)) {
          // 只有这个配置才可以选择变量
          isCustom = true
          for(const index in val.item.linked) {
            const item = val.item.linked[index]
            if (item.datatype !== 'custom') {
              isCustom = false
              break
            }
          }
        }
        // 如果是纯变量 那就不用选择数据也可以
        if (!isCustom) {
          this.$message.warning('请选择一条数据~~')
          return
        }
      }
      // 对象是明细才并且配置是按钮才给
      val.value = this.tableSelectValue
      this.$emit('singleRelevance', val)
    },
    searchRelevanceConfig ({search, i}) {
      console.log('搜索数据，直接查入到对应搜索', search)
      const e = this.layout.findIndex(its => its.i === i)
      let isCustom = false
      if (e !== -1) {
        if (search.isCustom) {
          isCustom = true
            // 筛选的是工坊的变量 就不通过value筛选
          if (this.layout[e].variableconfig && this.layout[e].variableconfig.length > 0) {
            const variableconfig = this.layout[e].variableconfig
            const index = variableconfig.findIndex(iter => { return search.customName === iter.name }) 
            if (index !== -1) {
              let val = ''
              if (Array.isArray(search.value) && variableconfig[index].type === 'date') {
                val = variableconfig[index].type2 === 'range' ? search.value : search.value[0]
              } else {
                val = Array.isArray(search.value) ? search.value.join() : search.value
              }
              // eslint-disable-next-line vue/no-mutating-props
              this.layout[e].variableconfig[index].value = val
            }
            // 存在第二个值
            if (search.customName2) {
              const index2 = variableconfig.findIndex(iter => { return search.customName2 === iter.name }) 
              if (index2 !== -1) {
                let val = ''
                if (Array.isArray(search.value) && variableconfig[index2].type === 'date') {
                  val = search.value.length > 1 ? search.value[1] : search.value[0]
                } else {
                  val = Array.isArray(search.value) ? search.value.join() : search.value
                }
                // eslint-disable-next-line vue/no-mutating-props
                this.layout[e].variableconfig[index2].value = val
              }
            }
          }
        }
        if (!isCustom) {
          const rules = JSON.parse(JSON.stringify(this.layout[e].rules))
          const rulesInd = rules.findIndex(ite => ite.filterId === search.filterId)
          // 查询是否存在对应值，没有的话就新增
          if (rulesInd !== -1) {
            // eslint-disable-next-line vue/no-mutating-props
            this.layout[e].rules[rulesInd] = search
          } else {
            rules.push(search)
            // eslint-disable-next-line vue/no-mutating-props
            this.layout[e].rules = rules
          }
        }
        this.$emit('contentSearch', e)
      }
    },
/*
    upDrage (val) {
      this.$emit('containerDrage', {i: this.config.i, val: !val})
    },
*/
    addCount () {
      // 固定的，去编辑栏目
      this.$emit('addCount')
    },
    getList (arr) {
      const ars = []
      for (const its of arr) {
        const id = typeof its === 'object' ? its.i : its
        const ind = this.layout.findIndex(ite => {
          return ite.i === id
        })
        if (ind !== -1) ars.push(ind)
      }
      return ars
    },
/*
    getList (arr) {
      return arr.filter(its => {
        const id = typeof its === 'object' ? its.i : its
        return this.layout.findIndex(ite => {
          return ite.i === id
        }) !== -1
      })
    },
*/
    changeSontoFa (val) {
      this.$emit('containerText', val)
    },
    indicatorsChange (val) {
      val.i = this.config.children[val.index].i
      this.$emit('containerIndicatorsChange', val)
    },
    sumPageChange (val) {
      val.i = this.config.children[val.index].i || this.config.children[val.index] && this.config.children[val.index].children && this.config.children[val.index].children[0]
      // val.i = this.config.children[val.index].i
      console.log('汇总切页', val, this.config)
      this.$emit('containerSumPageChange', val)
    },
    // 汇总
    tableMerge (listTable, datas) {
      let ars = [];
      let tableData = listTable;
      let retName = '';
      for (let a = 0; a < (datas.row || []).length; a++) {
        let arsArr = [];
        let post = 0;
        let rowNames = filterStr(datas.row[a].name);
        if (a > 0) retName = filterStr(datas.row[a - 1].name);
        for (let i = 0; i < tableData.length; i++) {
          if (i === 0) {
            arsArr.push(1);
            post = 0;
          } else {
            // 这里需要区分 row 是不是第一个
            if (a === 0) {
              if (JSON.stringify(tableData[i][rowNames]) === JSON.stringify(tableData[i - 1][rowNames])) {
                arsArr[post] += 1;
                arsArr.push(0);
              } else {
                arsArr.push(1);
                post = i;
              }
            } else {
              let one = tableData[i][retName] + tableData[i][rowNames];
              let two = tableData[i - 1][retName] + tableData[i - 1][rowNames];
              if (one === two) {
                arsArr[post] += 1;
                arsArr.push(0);
              } else {
                arsArr.push(1);
                post = i;
              }
            }
          }
        }
        ars.push(arsArr);
      }
      return ars;
    },
    // 汇总表格列合并计算
    tableMergeFun (fun, item) {
      let info = fun;
      return this.tableMerge(info, item);
    },
    // 汇总表格截取数据
    tableFun (arr, curpage, articel) {
      let stat = curpage * articel;
      let end = stat - articel;
      return arr.slice(end, stat);
    },
    pageChange (val) {
      val.i = this.config.children[val.index].i || this.config.children[val.index].children[0]

      // val.i = this.config.children[val.index].i
      this.$emit('containerPageChange', val)
    },
    singleRelevance (val) {
      this.$emit('singleRelevance', val)
    },
    changeRelevanceFun (val) {
      this.$emit('changeRelevanceFun', val)
    },
    // 滚动加载
    loadPage (val) {
      const i = this.config.children.findIndex(its => {
        if (its.children && Array.isArray(its.children)) {
          return its.children.findIndex(it => it === val.i)
        } else {
          return its.i === val.i
        }
      })

      if (i !== -1) {
        // const item = JSON.parse(JSON.stringify(this.config.children[i]))
        // item.curpage += 1
        const item = JSON.parse(JSON.stringify(val))
        item.curpage += 1
        this.$emit('upLoadPage', item)
      }
    },
    // 高度获取
    getHeight (item) {
      const h = !item.nameShow || item.toolbar ? 50 : 0
      let h1 = !item.loadSetting || item.loadSetting === 'pages' ? 30 : 0
      // const h1 = !item.loadSetting || item.loadSetting === 'pages' ? 50 : 0
      // const h2 = item.toolbar ? 50 : ''
      // if (item.upRevise) h1 = h1 + 37
      if (this.getLegend(item).length > 0) {
        h1 += 36
      }
      const oc = {
        height: 'calc(100% - ' + (h + h1) + 'px)'
        // height: 'calc(100% - ' + (h + h1 + h2) + 'px)'
      }
      if (item.row && item.row[0] && item.row[0].partition) oc.overflowY = 'auto'
      return oc

      // const h = !item.nameShow ? 50 : 0
      // const h1 = !item.loadSetting || item.loadSetting === 'pages' ? 50 : 0
      // const h2 = item.toolbar ? 20 : 0
      // return {
      //   height: 'calc(100% - ' + (h + h1 + h2) + 'px)'
      // }
    },
    handle (e, i) {
      if (!e.item) e.i = i
      e.iIndex = this.index
      this.$emit('containerHandle', e)
    },
    drop (e) {
      console.log('drop:', e)
      const data = event.dataTransfer.getData("nodeData");
      // 如果当前已经有了组件，则暂时不可添加其他组件
      if (this.config.children[this.config.selected] && this.config.children[this.config.selected].children && this.config.children[this.config.selected].children.length > 0) {
        this.$message.warning('当前栏目已有配置组件！！')
        return
      }
      if (this.isFrontEnd && data && data !== 'container' && data !== 'Sizer' && data !== 'mutual') {
        this.$emit('addContainer', {
          index: this.index,
          type: data
        })
      }
    },
    allowDrop (event) {
      event.preventDefault();
    },
		// 背景填充设置
		bgfillSet(bgfllStyle,transparentBackground){
			if(bgfllStyle && !transparentBackground){
				let fillstyle = {}
				if(bgfllStyle.bgstyle === 'picture'){
					// 背景填充图片
					if(bgfllStyle.picture.layout === 'default'){
						// 原大小填充
						fillstyle.background = `url('${this.$imgurl + bgfllStyle.picture.url}') no-repeat`
					}else if(bgfllStyle.picture.layout === 'adaption'){
						// 自适应填充
						fillstyle.background = `url('${this.$imgurl + bgfllStyle.picture.url}') no-repeat`
						fillstyle.backgroundSize = '100% 100%'
					}
				}else if(bgfllStyle.bgstyle === 'color'){
					// 背景填充颜色
					fillstyle.backgroundColor = bgfllStyle.color
				}
				return fillstyle
			}else{
				return ''
			}
		},
		// - 功能区域--编辑功能
    async editToolsFun (datas) {
      console.log('编辑功能', datas)
			this.goEdit = cloneDeep(datas)
      this.isEdit = true
    },
  }
}
</script>

<style scoped lang="scss">
.img-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  &:not(:empty) {
    margin-bottom: 5px;
    margin-top: 6px;;
  }
  .img-tt {
    display: flex;
    align-items: center;
    margin-right: 14px;
    // margin-bottom: 5px;
    // margin-top: 6px;;
    &:last-child {
      margin-right: 0;
    }
  }
  .img-tt-i {
    width: 25px;
    height: 25px;
  }
  .img-tt-v {
    font-size: 14px;
    color: #666;
  }
}

.revise {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
}
.content {
  height: calc(100% - 58px);
  // height: calc(100% - 101px);
  position: relative;
  //padding-left: 16px;
  //padding-right: 16px;
  .content-list {
    position: relative;
    width: calc(100% - 32px);
    //width: 100%;
    height: 100%;
    // overflow: hidden;
    padding-left: 16px;
    padding-right: 16px;
    .grid-table {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    :deep(.selectBoxArea) {
      height: auto;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  .grid-text {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    cursor: auto;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
  .header-style-two {
    border: 1px solid #DEE0E2;
  }
}
.no-data {
  text-align: center;
  position: relative;
  top: calc(50% - 45px);
  color: #999;
}
.no-content {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .no-content-icon {
    font-size: 18px;
    padding: 21px;
    border: 1px dashed #DCDEE0;
    background-color: #F7F8FA;
    border-radius: 4px;
    color: #999999;
  }
  .no-content-text {
    padding-top: 16px;
    color: #333333;
    font-size: 14px;
  }
  .add-count {
    color: #4e86ff;
    cursor: pointer;
  }
}
.content-left {
  width: calc(100% - 108px);
  max-width: calc(100% - 108px);
  // width: calc(100% - 32px);
  // max-width: calc(100% - 32px);
  height: 100%;
  padding-right: 0;
}
.content-left-two {
  width: calc(100% - 66px);
  max-width: calc(100% - 66px);
}
.grid-nav {
  height: 45px;
  // position: absolute;
  // right: 10px;
  // bottom: 0;
  overflow: hidden;
}
</style>
